export default "__VITE_ASSET__48d4a9de__"